import React from "react";
import { useTranslation } from "react-i18next";
import "./Modal.css";

type ModalProps = {
  isOpen: boolean;
  children: React.ReactNode;
  closeOnOverlayClick?: boolean;
  onRequestClose?: () => void;
  showCloseButton?: boolean;
  closeButtonLabel?: string;
  overlayClassName?: string;
  contentClassName?: string;
};

function joinClasses(...classNames: Array<string | undefined>): string {
  return classNames.filter(Boolean).join(" ");
}

export default function Modal({
  isOpen,
  children,
  closeOnOverlayClick = false,
  onRequestClose,
  showCloseButton = false,
  closeButtonLabel,
  overlayClassName,
  contentClassName
}: ModalProps) {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!closeOnOverlayClick || !onRequestClose) {
      return;
    }

    if (event.target === event.currentTarget) {
      onRequestClose();
    }
  };

  return (
    <div
      aria-modal="true"
      className={joinClasses("modal-overlay", overlayClassName)}
      onClick={handleOverlayClick}
      role="dialog"
    >
      <div className={joinClasses("modal-content", contentClassName)}>
        {showCloseButton && onRequestClose && (
          <button
            aria-label={closeButtonLabel || t("components.modal.fecharModal")}
            className="modal-close-button"
            onClick={onRequestClose}
            type="button"
          >
            x
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
